import React from 'react';
import { Typography, Box } from '@mui/material';
import LocalParkingIcon from '@mui/icons-material/LocalParking'; // Import the parking icon

const ParkingDisplay = ({ parkingTypes }) => {
  // Handle null or undefined parkingTypes
  if (!parkingTypes) {
    return null; // Do not render anything if parkingTypes is null or undefined
  }

  // Map of model field names to display names
  const parkingFields = [
    { field: "underground_lot", label: "Underground lot" },
    { field: "outside_lot", label: "Outside lot" },
    { field: "garage_lot", label: "Garage lot" },
    { field: "carport_lot", label: "Carport lot" },
    { field: "stacked_lot", label: "Stacked lot" },
    { field: "free_parking_area", label: "Free parking area" },
    { field: "street", label: "Street parking" },
    { field: "valet", label: "Valet" },
    { field: "bike_parking", label: "Bike parking" },
    { field: "ev_charging", label: "EV charging" },
  ];

  // Filter fields with a count > 0
  const availableParking = parkingFields
    .filter(({ field }) => parkingTypes[field] > 0)
    .map(({ label }) => label)
    .join(", ");

  // Only render if there is available parking
  if (!availableParking) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-center', marginTop: '0px' }}>
      <LocalParkingIcon color="secondary"/>
      <Typography variant="body2" sx={{ ml: 1 }} color="textSecondary">
        {availableParking}
      </Typography>
    </Box>
  );
};

export default ParkingDisplay;